import React from 'react';
import QuickChatActions from './QuickChatActions';
import QuickFunctionActions from './QuickFunctionActions';

interface QuickActionsDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    activeTab: 'chat' | 'functions';
    onTabChange: (tab: 'chat' | 'functions') => void;
    onQuickMessage: (message: string) => void;
    onVoiceRecord: () => void;
    onCameraCapture: () => void;
    onFileUpload: () => void;
    onScheduleMeeting: () => void;
    isVoiceRecording: boolean;
    voiceConnectionStatus: string;
    isCameraLoading: boolean;
}

const QuickActionsDrawer: React.FC<QuickActionsDrawerProps> = ({
    isOpen,
    onClose,
    activeTab,
    onTabChange,
    onQuickMessage,
    onVoiceRecord,
    onCameraCapture,
    onFileUpload,
    onScheduleMeeting,
    isVoiceRecording,
    voiceConnectionStatus,
    isCameraLoading
}) => {
    if (!isOpen) return null;

    return (
        <>
            {/* 遮罩层 */}
            <div
                className="fixed inset-0 bg-black bg-opacity-50 z-40"
                onClick={onClose}
            ></div>

            {/* 抽屉内容 */}
            <div className="fixed bottom-0 left-0 right-0 md:left-1/2 md:transform md:-translate-x-1/2 md:max-w-2xl lg:max-w-4xl bg-white rounded-t-2xl z-50 animate-slide-up max-h-[70vh] overflow-hidden">
                <div className="p-4">
                    {/* 拖拽指示器 */}
                    <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mb-4"></div>

                    {/* Tab 标签页 */}
                    <div className="flex space-x-1 mb-4 bg-gray-100 rounded-lg p-1">
                        <button
                            onClick={() => onTabChange('chat')}
                            className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                                activeTab === 'chat'
                                    ? 'bg-white text-gray-900 shadow-sm'
                                    : 'text-gray-600 hover:text-gray-900'
                            }`}
                        >
                            快速对话
                        </button>
                        <button
                            onClick={() => onTabChange('functions')}
                            className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                                activeTab === 'functions'
                                    ? 'bg-white text-gray-900 shadow-sm'
                                    : 'text-gray-600 hover:text-gray-900'
                            }`}
                        >
                            快速功能
                        </button>
                    </div>

                    {/* Tab 内容 */}
                    <div className="max-h-[50vh] overflow-y-auto">
                        {activeTab === 'chat' ? (
                            <QuickChatActions
                                onQuickMessage={onQuickMessage}
                                onClose={onClose}
                            />
                        ) : (
                            <QuickFunctionActions
                                onVoiceRecord={onVoiceRecord}
                                onCameraCapture={onCameraCapture}
                                onFileUpload={onFileUpload}
                                onScheduleMeeting={onScheduleMeeting}
                                onClose={onClose}
                                isVoiceRecording={isVoiceRecording}
                                voiceConnectionStatus={voiceConnectionStatus}
                                isCameraLoading={isCameraLoading}
                            />
                        )}
                    </div>

                    {/* 取消按钮 */}
                    <button
                        onClick={onClose}
                        className="w-full mt-4 p-4 bg-gray-100 rounded-xl text-gray-700 font-medium hover:bg-gray-200 transition-colors"
                    >
                        取消
                    </button>
                </div>
            </div>
        </>
    );
};

export default QuickActionsDrawer;
